import ErrorInfo from '@/components/error/ErrorInfo/ErrorInfo';
import Layout from '@/components/Layout/Layout';

const ErrorFallback = () => (
  <Layout>
    <ErrorInfo browserNavigationEnabled />
  </Layout>
);

export default ErrorFallback;
